// extracted by mini-css-extract-plugin
export var csatScore = "_hd-5";
export var header = "_hd-1";
export var panelWrapper = "_hd-2";
export var postPreview = "_hd-3";
export var rightContent = "_hd-0";
export var wrappingText = "_hd-4";